import gql from "graphql-tag"

export const getSsoPayload = gql`
  {
    ssoCheckUrl
    ssoLoginUrl
    isUserLoggedIn
    loggedOutSid
    environment
  }
`

export const getCurrentUser = () => gql`
  {
    currentUser {
      avatarUrl
      company {
        name
      }
      enabledFeatures
      email
      fullName
      id
      permissions
      position
      trackingData
      hashedEmail
    }
  }
`

export const getLanguage = () => gql`
  {
    currentUser {
      locale
    }
  }
`

export const logout = gql`
  mutation logout {
    logout {
      success
    }
  }
`

export const getTotalUnreadMessages = gql`
  query chatsList {
    viewer {
      chats(first: 1, filter: UNREAD) {
        total
      }
    }
  }
`
